import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-white py-16 md:py-24" data-id="element-185" data-mp="1026tkephop2s">
      <div className="mx-auto w-full max-w-narrow px-5 md:px-8" data-id="element-186" data-mp="l44pm3ejq1l0">
        <header className="text-center" data-id="element-187" data-mp="q2fz2d0xia2p">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-rose-600" data-id="element-188" data-mp="q3h86bydwmhs">
            Sin sorpresas
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-189" data-mp="1ducxn2fdb5lv">
            Exactamente qué recibís hoy
          </h2>
        </header>

        <ul className="mt-12 divide-y divide-gray-200 overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-gray-200" data-id="element-190" data-mp="1404idgfcl95n">
          {deliverables.map(item => <li key={item} className="flex items-start gap-4 px-5 py-5 md:px-8" data-id="element-191" data-mp="1wq32cxeoqg3g">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mint-500 text-white" data-id="element-192" data-mp="21hux7k4vj7ze">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-193" data-mp="2vgbzba8mrxv7" />
              </span>
              <span className="text-lg leading-snug text-ink" data-id="element-194" data-mp="2qi23qyizuv92">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}